import React, { useEffect, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import Loading from './Loading'

import { getReservation } from '../services/GetReservation'
import { getCountries } from '../services/GetCountries'
import { getGroupsDetails } from '../services/GetGroupsDetails'
import { getBlockedTaxNumbers } from '../services/ValidateTaxNumber'
import { verifyReservationWithRA } from '../pages/review-rental-agreement/api'

import { DomainContext } from '../domain-repository/DomainRepository'
import { GroupsImagesContext } from '../domain-repository/GroupsImagesRepository'

export default function AutoSearchReservation({ params, handleNotFound, handleFound, handleRAFound, secondTry = false }) {
  const { i18n, t } = useTranslation()
  const { getSetGroupsConfigurations } = useContext(GroupsImagesContext)
  const {
    setReservation,
    setCountries,
    setDriverInfo,
    language,
    setLanguage,
    setKioskCurrentStationId,
    setPickupDate,
    setAppFlowConfigs,
    appVersionId,
    setSessionId,
    setGroupsDetails,
    setBlockedTaxNumbersList,
  } = useContext(DomainContext)

  useEffect(() => {
    getReservationFromReference()
  }, [])

  async function getReservationFromReference() {
    const resReference = params.number
    const stationId = params.pickupStation
    const pickupDate = params.pickupDate
    const lang = params.lang

    let formatedResNumberOrRefMatches = resReference.match(/(.*)count$/i)

    const groupConfig = await getSetGroupsConfigurations()

    const blockedTaxNumbersList = await getBlockedTaxNumbers()
    setBlockedTaxNumbersList(blockedTaxNumbersList.blockedTaxNumbers)

    const translations = i18n?.getResourceBundle(i18n.language)

    Promise.all([
      getReservation({ resNumberOrReference: formatedResNumberOrRefMatches && formatedResNumberOrRefMatches.length > 1 ? formatedResNumberOrRefMatches[1] : resReference, stationId, resCheckOutDate: pickupDate, appVersionId, language, autoSearch: true, secondTry }),
      getCountries(),
      getGroupsDetails(Object.keys(groupConfig)),
    ])
      .then(([reservation, countries, groups]) => {

        if (!reservation || !countries || !groups || groups.length === 0) {
          handleNotFound()
        } else {
          setReservation(reservation)
          setCountries(countries.map(c => ({ ...c, name: translations[`country_${c.countryID}`] || '' })))
          setGroupsDetails(groups.groupsDetails)
          setDriverInfo(reservation.listReservation)
          setAppFlowConfigs(reservation.appFlowConfigs)
          setSessionId(reservation.sessionId)
          handleFound()
        }
      })
      .catch(err => {
        handleNotFound(err)
      });
  }

  return (
    <Loading active={true} />
  )
}
